import React, { useEffect } from "react";
import Adminservice from "../../services/admin.service";
import { Button, Table, Spinner } from "react-bootstrap";
import { useState } from "react";
import PaginationS from "./Pagination";
import dataDummy from "../../file/DataDummy-Test-Table.json";

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [update, setUpdate] = useState(true);
  const [dataWait, setDataWait] = useState([]);
  const [dataSuc, setDataSuc] = useState([]);
  const [data, setData] = useState();
  //const data = dataDummy;

  const corporationApproval = (uuid) => {
    Adminservice.ApproveCorporation(uuid)
      .then((res) => {
        setTimeout(() => {
          setLoading(false);
          setUpdate(!update);
        }, 500);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    console.log("Refesh Data")
    const check = Adminservice.GetCorporationApproval();
    if (check != null) {
      check.then((res) => {
        console.log(res.data.data)
        setData(res.data.data);
        let datawait = [];
        let datasuc = [];
        setTimeout(() => {
          res.data.data.forEach((field, index) => {
            if (field.user_type === 2) {
              console.log(field)
              datawait.push(field);
            } else {
              datasuc.push(field);
            }
          });
          setDataWait(datawait);
          setDataSuc(datasuc);
          setLoading(false);
        }, 500);
      }).catch((error)=>{
        console.log(error)
      })
    }
  }, [update]);

  const [watingSearchValue,setWaitingSeachValue] = useState(["company_name","legalentity_number"])
  const [watingData, setWaitingData] = useState([]);
  const [startArrWait, setStartArrWait] = useState(0);
  const handleWaitingChange = (newPortion, startarr) => {
    setWaitingData(newPortion);
    setStartArrWait(startarr);
  };

  const [SucSearchValue,setSucSeachValue] = useState(["company_name","legalentity_number"],2)
  const [portionToMaps, setPortionToMaps] = useState([]);
  const [startArr, setStartArr] = useState(0);
  const handlePortionChange = (newPortion, startarr) => {
    setPortionToMaps(newPortion);
    setStartArr(startarr);
  };
  console.log(update)
  
  return (
    <>
      {loading === true ? (
        <>
          <div className="loading-container">
            {" "}
            <Spinner animation="border" variant="secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </>
      ) : (
        <>
          <div className="container-main">
            <div className="table-card-header">
              <h4 className="header-main" style={{ color: "white" }}>
                รายการรอดำเนินการ
              </h4>
            </div>
            <div>
              <div style={{textAlign:"end", marginTop:"35px"}}>
                <p>จำนวน {dataWait.length}</p>
              </div>
              <Table striped bordered={false} hover className="table-main" style={{marginTop:"0px"}}>
                <thead>
                  <tr style={{ fontSize: "22px" }}>
                    <th>ลำดับ</th>
                    <th>ชื่อหน่วยงาน</th>
                    <th>เลขทะเบียนนิติบุคคล</th>
                    <th>รหัสสาขา (ภพ. 20) </th>
                    <th> สถานะ</th>
                  </tr>
                </thead>
              {watingData.length===0? (
              <>
                <thead>
                <th colSpan={6}>
                  <h4 className="header-main">ไม่พบข้อมูล</h4>
                </th>
              </thead>
              </>):(
                <tbody>
                {watingData.map((field, index) => {
                  const currentIndex = startArrWait + index + 1;
                  return field.user_type === 2 ? (
                    <tr key={currentIndex} style={{ fontSize: "18px" }}>
                      <td>{currentIndex}</td>
                      <td>{field.company_name}</td>
                      <td>{field.legalentity_number}</td>
                      <td>{field.branch_code}</td>
                      <td>
                        <Button
                          variant="warning"
                          onClick={() => {
                            corporationApproval(field.uuid);
                            setLoading(true);
                          }}
                        >
                          อนุมัติ
                        </Button>
                      </td>
                    </tr>
                  ) : (
                    <></>
                  );
                })}
               </tbody>
              )}
                {/* body */}
               
                  
                
              </Table>
            </div>
            <PaginationS
              data={dataWait}
              onPortionChange={handleWaitingChange}
              searchValue={watingSearchValue}
            />  
          </div>

          <div className="container-main">
            <div className="table-card-header">
              <h4 className="header-main" style={{ color: "white" }}>
                รายการขึ้นทะเบียนหน่วยงาน
              </h4>
            </div>
            <div>
            <div style={{textAlign:"end", marginTop:"35px"}}>
                <p>จำนวน {dataSuc.length}</p>
              </div>
              <Table striped bordered={false} hover className="table-main" style={{marginTop:"0px"}} >
                <thead>
                  <tr style={{ fontSize: "22px"  }}>
                    <th>ลำดับ</th>
                    <th>ชื่อหน่วยงาน</th>
                    <th>เลขทะเบียนนิติบุคคล</th>
                    <th>รหัสสาขา (ภพ. 20) </th>
                    <th> สถานะ</th>
                  </tr>
                </thead>
            {/* body */}
                {portionToMaps.length===0? (
              <>
                <thead>
                <th colSpan={6}>
                  <h4 className="header-main">ไม่พบข้อมูล</h4>
                </th>
              </thead>
              </>):(
                <tbody>
                {portionToMaps.map((field, index) => {
                  const currentIndex = startArr + index + 1;
                  return field.user_type === 2 ? (
                    null
                  ) : (
                    <tr key={currentIndex} style={{ fontSize: "18px" }}>
                    <td>{currentIndex}</td>
                    <td>{field.company_name}</td>
                    <td>{field.legalentity_number}</td>
                    <td>{field.branch_code}</td>
                    <td style={{ color: "green" }}>อนุมัติแล้ว</td>
                  </tr>
                  );
                })}
               </tbody>
              )}
             
              </Table>
            </div>

            <PaginationS
              data={dataSuc}
              onPortionChange={handlePortionChange}
              searchValue={SucSearchValue}
            />
          </div>
        </>
      )}
    </>
  );
};

export default Dashboard;
